import { ReactComponent as LogoIconSVG } from '@/assets/icons/LogoIcon.svg';
import { SVGProps } from 'react';

const LogoIcon = (props: SVGProps<SVGSVGElement>) => <LogoIconSVG {...props} />;

export default LogoIcon;
